import { AppBadge } from '@9b3kuq5phwuk4txw/kiban-react-ui'
import type { Division } from '@/lib'

const oldDivisionBadge = (
  <AppBadge color='gray' className='text-[10px] px-1 py-0'>
    旧部署
  </AppBadge>
)

const notAssignableBadge = (
  <AppBadge color='red' className='text-[10px] px-1 py-0'>
    直アサイン不可
  </AppBadge>
)

export function getDivisionBadge(d: Division): React.ReactNode | undefined {
  if (!d.enabled) return oldDivisionBadge
  if (!d.is_assignable) return notAssignableBadge
  return undefined
}
